import Spinners from 'components/Common/Spinner'
import React from 'react'

const Logout = () => {
  return (
    <Spinners/>
  )
}

export default Logout